export default "__VITE_ASSET__BGZMmKk1__"